import { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import { SiteContentContext } from "../context/SiteContentContext";
import ContactModal from "./contactModal";
import Modal from "./modal";

export default function StickyContactButton() {
  const { getContent } = useContext(SiteContentContext);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Hide on the dedicated contact page (/:locale/contact)
  if (/\/contact(\/.*)?$/.test(location.pathname)) return null;

  const label = getContent("contact.sticky_button_label", "Kontakta oss");

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={label}
        data-testid="sticky-contact-button"
        className="fixed bottom-6 right-4 z-40 flex items-center gap-2 bg-primary hover:bg-primary800 text-inverse px-4 py-3 rounded-full shadow-lg transition-colors focus:outline-none focus:ring-2 focus:ring-primary500"
      >
        {/* Phone icon */}
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <title>Telefon</title>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
        </svg>

        {/* Divider */}
        <span className="w-px h-5 bg-white/40" aria-hidden="true" />

        {/* Email icon */}
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <title>E-post</title>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      </button>

      {open && (
        <Modal
          onClose={() => setOpen(false)}
          header={getContent("contact.modal_heading", "Kontakta oss")}
          showCloseButton={false}
          full={true}
          size="w-11/12 max-w-2xl max-h-[90vh]"
          overflow="overflow-y-auto"
        >
          <ContactModal />
        </Modal>
      )}
    </>
  );
}
